import { useState } from 'react';
import { EyeOutlined } from '@ant-design/icons';
import { NodeAccessApproval, NodeAccessProfileStatus } from '@prisma/client';
import { Button, ModalProps } from 'antd';
import { DropdownButtonProps } from 'antd/es/dropdown';

import { ApprovalForm } from '../forms';

export const useApprovalActions = () => {
  const [selectedApproval, setSelectedApproval] = useState<NodeAccessApproval | undefined>();

  const toggleApprovalModal = (record?: NodeAccessApproval) => {
    setSelectedApproval(record);
  };

  const getActionButton = (record: NodeAccessApproval, props?: DropdownButtonProps) =>
    record.status === NodeAccessProfileStatus.PENDING ? (
      <Button icon={<EyeOutlined />} onClick={() => toggleApprovalModal(record)} {...props}>
        Review
      </Button>
    ) : (
      <Button icon={<EyeOutlined />} onClick={() => toggleApprovalModal(record)} {...props}>
        Details
      </Button>
    );

  const getApprovalModalProps = (props?: ModalProps): ModalProps => ({
    centered: true,
    title: `Review ${selectedApproval?.name}`,
    width: 1100,
    ...props,
    children: selectedApproval && <ApprovalForm record={selectedApproval} onCancel={() => toggleApprovalModal()} />,
    footer: null,
    open: !!selectedApproval,
    destroyOnClose: true,
    onCancel: () => toggleApprovalModal(),
  });

  return { getActionButton, getApprovalModalProps };
};
